import { render, staticRenderFns } from "./Tabela.vue?vue&type=template&id=a6057712"
import script from "./Tabela.vue?vue&type=script&setup=true&lang=js"
export * from "./Tabela.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports